// @flow
import {createReducer} from 'modules/redux/reducer';
import {USER_ACTION_TYPE} from 'modules/user/constants';
import type {TUserTotal, TUser, TUserData, TUserId} from 'modules/user/types';

export type TSetUserList = {
    payload: TUser[] | null,
    type: typeof USER_ACTION_TYPE.GET_USER_LIST,
};
export type TSetUserData = {
    payload: TUserData,
    type: typeof USER_ACTION_TYPE.GET_USER_DATA,
};
export type TSetUserTotal = {
    payload: TUserTotal,
    type: typeof USER_ACTION_TYPE.SET_USER_TOTAL,
};
export type TUserState = {
    data: TUserData,
    total: TUserTotal,
    userList: TUser[] | null,
};

export const initialState: TUserState = {
    data: {},
    total: 0,
    userList: null,
};

const reducer = {
    [USER_ACTION_TYPE.GET_USER_DATA]: (state, payload: TUserData) => {
        return {
            ...state,
            data: payload,
        };
    },
    [USER_ACTION_TYPE.GET_USER_LIST]: (state, payload: TUser[] | null) => {
        return {
            ...state,
            userList: payload,
        };
    },
    [USER_ACTION_TYPE.SET_USER_TOTAL]: (state, payload: TUserTotal) => ({
        ...state,
        total: payload,
    }),
    [USER_ACTION_TYPE.TOGGLE_CHECKED_USER]: (state, payload: TUserId) => {
        const newState = JSON.parse(JSON.stringify(state));
        newState.data[payload].checked = !newState.data[payload].checked;
        return newState;
    },
    [USER_ACTION_TYPE.CHECK_ALL_USERS]: (state) => ({
        ...state,
        data: Object.entries(state.data).reduce((all, [key, one]: any) => {
            one.checked = true;
            all[key] = one;
            return all;
        }, {}),
    }),
    [USER_ACTION_TYPE.UNCHECK_ALL_USERS]: (state) => ({
        ...state,
        data: Object.entries(state.data).reduce((all, [key, one]: any) => {
            one.checked = false;
            all[key] = one;
            return all;
        }, {}),
    }),
};

export const userReducers = createReducer(initialState, reducer);
